import { notification } from "antd";

export const openNotification = (platform) => {
  const args = {
    message: "Login Required",
    description:
      `You are not logged in with ${platform}. If you want to log in, please go to the ${platform} tab.`,
    duration: 8,
  };
  notification.open(args);
};

